<template>
  <base-select
    :model-value="modelValue"
    :options="preparedOptions"
    :placeholder="$t('WithdrawToCard | selectProviderPlaceholder')"
    @update:modelValue="handleSelect"
  >
    <template #trigger>
      <template v-if="selectedProviderDescription">
        <span class="text">{{ $t(selectedProviderDescription.title) }}</span>
      </template>
      <template v-else>
        {{ $t('WithdrawToCard | selectProviderPlaceholder') }}
      </template>
    </template>

    <template #item="{ data }">
      <span class="text">{{ $t(data.title) }}</span>
    </template>
  </base-select>
</template>

<script>
import BaseSelect from '@emcd-shared/base-select'

export default {
  name: 'SelectProvider',

  props: {
    // Selected provider
    modelValue: {
      required: true,
    },
    // All available providers
    options: {
      type: Array,
    },
  },

  emits: ['update:modelValue'],

  components: {
    BaseSelect,
  },

  computed: {
    // Object with description of the selected provider
    selectedProviderDescription() {
      return this.options.find((provider) => provider.value === this.modelValue)
    },

    // Augmented and sorted options array
    preparedOptions() {
      if (!this.options) return []

      return this.options.map((option) => ({
        ...option,
        optionValue: option.value, // BaseSelect expects optionValue
      }))
    },
  },

  methods: {
    handleSelect(value) {
      this.$emit('update:modelValue', value)
    },
  },
}
</script>
